<template>
  <el-dialog
    v-model="dialogVisible"
    :append-to-body="false"
    class="custom-service-dialog"
    :show-close="false"
    :style="{ maxWidth: '1200px', width: '90%', background: '#252C3D' }"
  >
    <img src="@/assets/images/bg/dailog-bg.webp" class="bg">
    
    <div class="custom-wrapper">
      <!--头部-->
      <div class="header flex justify-between align-center">
        <div class="cumtom-title">{{t('forecast.service')}}</div>
         <el-icon @click="handleClose"><CloseBold /></el-icon>
      </div>
       <div class="top-bar">
        <span class="location"> <img src="@/assets/images/icon/icon-location.webp" alt="location" />
          {{locale=="zh-CN"?currentCity?.parent_names:currentCity?.parent_ennames}},{{locale=="zh-CN"?currentCity?.name:currentCity?.enname}}
        </span>
        <span class="date">{{formatDate(new Date(),locale)}} {{getWeekDay()}} {{locale=='zh-CN'?'农历'+getLunarDate():''}}</span>
      </div>
       <!-- 运动提示区域 -->
      <div class="sport-tip flex">
        <div class="sport-icon">
        <el-image :src="staticURL('/serviceIcon/' + lifeIndexIconId + '.png')">
                  <template #error>
                      <img :src="staticURL('/serviceIcon/default.png')" />
                  </template>
          </el-image>
        </div>
        <div class="sport-text">
          <h3>{{serviceItem?.index_type}}</h3>
          <p class="subtitle">{{serviceItem?.index_level_desc}}</p>
          <p class="warning flex align-center">
          <span class="flex aligin-center">
            <el-icon><WarningFilled /></el-icon>
          </span>
          {{t('weather.prompt')}}: {{serviceItem?.index_desc}}
          </p>
        </div>
      </div>
      <!-- 天气卡片区域 -->
      <div class="card-group">
        <div class="weather-card" v-for="(item, index) in serviceItem?.data_List" :key="index" v-show="index<3">
          <h4 class="font24 card-date">{{ item?.predict_date ? getDisplayDate(item?.predict_date) : '' }}</h4>
          <div class="weather-icon">
            <img :src="weatherIconUrl+item.icon_day+'.png'"/> 
          </div>
          <p class="font24 weather-type">{{item.weather_day}}</p>
          <p class="font16 temperature">{{ item.temp_low }}° - {{ item.temp_high }}°</p>
          <div class="pollution-tag" :style="{ background: aqiTagStyle(index).color }">{{ aqiTagStyle(index).level }}</div>
          <p class="font16 sport-tyoe">{{ item?.index_type }}</p>
          <p class="font16 sport-desc">{{ item?.index_desc }}</p>
        </div>
      </div>
    </div>
   </el-dialog>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { CloseBold, WarningFilled } from '@element-plus/icons-vue' // 显式导入所有使用的图标
import type { WeatherCurrentIndex, WeatherResponse } from '~/types'
import { getAQIInfo,formatDateToChineseMd,getLunarDate,getWeekDay,formatDate} from '@/utils/utils'
import { getLifeIndexIconId } from '@/utils/lifeIndex'
const weatherIconUrl = staticURL('/weather/w')
import { useI18n } from 'vue-i18n'
const nuxtApp = useNuxtApp()
const { locale,t } = useI18n()
const props = withDefaults(
  defineProps<{
    serviceVisible?: boolean;
    serviceItem?: WeatherCurrentIndex;
    aqi_forecast:WeatherResponse['aqi_forecast'];
    currentCity:any;
  }>(),
  {
    serviceVisible: false,
    serviceItem:undefined,
    aqi_forecast:() => [],
    currentCity:{}
  }
)

// 定义事件
const emit = defineEmits<{
  (e: 'update:serviceVisible', value: boolean): void;
}>()

// 使用计算属性实现双向绑定
const dialogVisible = computed({
  get: () => props.serviceVisible,
  set: (value) => emit('update:serviceVisible', value)
})

const lifeIndexIconId = computed(() => getLifeIndexIconId(props.serviceItem))

const aqiTagStyle = (index: number) => {
  const aqi = props.aqi_forecast?.[index]?.aqi
  return aqi != null ? getAQIInfo(+aqi, nuxtApp) : { level: '', color: '', text: '' }
}

// 处理关闭事件
const handleClose = () => {
  emit('update:serviceVisible', false)
}

const getDisplayDate = (date: string) => {
  // 计算天数差,按时间戳计算
  const diffDays = Math.round((new Date(date).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24));
  const weekdays = [t('weekdays.0'),t('weekdays.1'),t('weekdays.2'),t('weekdays.3'),t('weekdays.4'),t('weekdays.5'),t('weekdays.6')]
  if (diffDays === -1) {
    return t('weather.yesterday');
  } else if (diffDays === 0) {
    return t('weather.today');
  } else if (diffDays === 1) {
    return t('weather.tomorrow');
  } else if (diffDays === 2) {
    return t('weather.afterTomorrow');
  } else {
    // 其他日期显示周几
    return weekdays[new Date(date).getDay()];
  }
}
</script>
<style scoped lang="scss">
  @use '@/assets/css/airorservice.scss'; // 使用 @import 替代 @use
</style>